import { render, staticRenderFns } from "./donate.vue?vue&type=template&id=34cfd08b&scoped=true"
import script from "./donate.vue?vue&type=script&lang=js"
export * from "./donate.vue?vue&type=script&lang=js"
import style0 from "./donate.vue?vue&type=style&index=0&id=34cfd08b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cfd08b",
  null
  
)

export default component.exports